/** Kept in its own module so tests can replace the full-page reload with a spy. */
export const reloadPage = () => {
  window.location.reload();
};
